// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_2_P7Qa","parallaxStyles":"_1HIcvB"};